export default __webpack_public_path__ + "static/media/PhantomSans0.8-Regular.117707bb.ttf";